// Externals
import type { Reducer } from 'redux';
import { initActionTypes } from '@makemydeal/dr-shared-store';

// Actions
import { Actions } from '../actionTypes/actionTypes';

// Types
import type { CapabilitiesReducerState } from './types';
import { getCapabilitiesInitialState } from './initialState';

/**
 * Reducer for the edition-based capabilities slice (F303238).
 *
 * The BFF resolves the dealer's edition to a `CapabilitiesState` and stamps the result onto
 * dealer settings; this reducer only stores it verbatim. It never resolves, merges or
 * defaults a capability map of its own — that would put a second source of truth on
 * the client, which the contract rules out.
 *
 * Both dealer-settings carriers are handled, because either can be the first to
 * arrive depending on how the app was entered:
 *   - bootstrap/init nests dealer settings two levels deep, under
 *     `dealerDetails.dealerSettings.dealerSettings`
 *   - the dealer-details API returns them one level deep, under `dealerSettings`
 * Both paths are the same ones the sibling `dealerReducer` reads dealer settings from.
 *
 * A payload without capabilities preserves prior state rather than wiping it, so a
 * later dealer-details response that omits the field cannot un-hydrate the slice.
 */
export const capabilities: Reducer<CapabilitiesReducerState> = (state = getCapabilitiesInitialState(), action: any) => {
    const { type, payload } = action;

    switch (type) {
        case initActionTypes.INIT_PENCIL_SUCCESS: {
            return payload?.dealerDetails?.dealerSettings?.capabilities ?? state;
        }

        case Actions.GET_DETAILS_SUCCESS: {
            return payload?.capabilities ?? state;
        }

        default: {
            return state;
        }
    }
};
